export default {
  title: '供应链管理',
  supplierList: '供应商列表',
};
